export default "__VITE_ASSET__rHYo$hZB__"